import { gql } from '@apollo/client';

export const CREATE_RATE_CARD = gql`
  mutation CreateRateCard($rateCard: RateCardCreateModelInput!) {
    createRateCard(rateCard: $rateCard) {
      name
      referenceId
      referenceCode
    }
  }
`;

export default CREATE_RATE_CARD;
